<template>
  <v-card
    class="mx-auto"
    :loading="loading"
    :outlined="outlined"
    :elevation="elevation"
    :raised="raised"
    :width="width"
    :height="height"
    color="white"
  >
    <!-- <v-card-title :class="inmueble.isDataBurbuja === 'yes' ? 'green lighten-1' : 'amber lighten-1'"> -->
    <v-card-title :class="statusFormComputed">
      <router-link :to="`/dashboard/inmuebles-detalle/${catastroSelect}/${inmueble.key}`">
        <span class="subtitle-1">{{inmueble.key}} - {{inmueble.inmueble.direccion}}</span>
      </router-link>
      <v-spacer></v-spacer>
      <v-menu bottom left>
        <template v-slot:activator="{ on }">
          <v-btn dark icon v-on="on">
            <v-icon>more_vert</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-tile v-for="(item, i) in menu.items" :key="i">
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text class="py-1 my-0">
      <v-layout>
        <v-flex xs6>
          <span class="amber--text">Link enviado:</span>
          <v-icon v-if="inmueble.inmueble.enviadoLink" class="green--text ml-1">check_circle_outline</v-icon>
          <v-icon v-else class="red--text ml-1">highlight_off</v-icon>
        </v-flex>
        <v-flex xs6>
          <span class="amber--text">Datos usuarios:</span>
          <v-progress-circular
            v-if="inmueble.isDataBurbuja === 'check'"
            indeterminate
            color="warning"
            size="16"
            width="2"
            class="ml-1"
          ></v-progress-circular>
          <v-icon
            v-else-if="inmueble.isDataBurbuja === 'yes'"
            class="green--text ml-1"
          >check_circle_outline</v-icon>
          <v-icon v-else-if="inmueble.isDataBurbuja === 'no'" class="red--text ml-1">highlight_off</v-icon>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-text class="pt-2 pb-0 my-0">
      <span class="grey--text">Propietarios:</span>
      <span
        :class="inmueble.usuarios.length ? 'green--text' : 'red--text'"
      >{{inmueble.usuarios.length}}</span>
      <!-- <span class="red--text"> / {{ propietariosForm.length }} / {{ propietariosFormNoMostrar }}</span> -->
      <v-btn
        :disabled="inmueble.usuarios.length > 0"
        class="ml-5"
        icon
        @click="addUser(inmueble.key)"
      >
        <v-icon class="blue--text">add_circle_outline</v-icon>
      </v-btn>
      <span :class="inmueble.usuarios.length > 0 ? 'grey--text' : 'blue--text'">Agregar Usuario</span>
    </v-card-text>

    <!-- <v-card-text class="pt-0 pb-0 my-0">
      <span class="grey--text">Co-Propietarios:</span>
      <span
        v-if="inmueble.dataBurbuja && inmueble.dataBurbuja.propietarios.length > 0"
        class="green--text"
      >{{inmueble.dataBurbuja.propietarios.length}}</span>
      <span v-else class="red--text">0</span>
    </v-card-text> -->

    <!-- <v-card-text class="pt-2 pb-0 my-0">
      <span class="grey--text">Firmas:</span>
      <span
        v-if="inmueble.dataBurbuja && inmueble.dataBurbuja.propietarios.length > 0 && inmueble.dataBurbuja[0]['firmas'].length"
        class="green--text"
      >{{inmueble.dataBurbuja[0]['firmas'].length}}</span>
      <span v-else class="red--text">0</span>
    </v-card-text> -->
    <v-card-text class="py-0 my-0">
      <v-icon v-if="inmueble.isEmail" class="green--text mx-1">mdi-email</v-icon>
      <v-icon v-else class="grey--text mx-1">mdi-email</v-icon>
      <v-icon v-if="inmueble.isTlf" class="green--text mx-1">mdi-phone</v-icon>
      <v-icon v-else class="grey--text mx-1">mdi-phone</v-icon>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions v-if="actions">
      <v-checkbox
        v-if="inmueble.usuarios[0]"
        :disabled="!inmueble.isTlf && !inmueble.isEmail"
        label="Enviar link"
        class="text--blue"
        v-model="inmueble.usuarios[0].invita"
      ></v-checkbox>
      <v-checkbox
        v-else
        :disabled="true"
        label="Enviar link"
        class="text--blue"
        v-model="invita"
      ></v-checkbox>
      <v-spacer></v-spacer>
      <v-btn outline color="primary" @click="editaData(inmueble)">Editar</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "FichaInmueble",
  props: ["inmueble", "catastroSelect"],
  data() {
    return {
      invita: false,
      menu: {
        items: [
          { title: 'Click Me' },
          { title: 'Click Me' },
          { title: 'Click Me' },
          { title: 'Click Me 2' }
        ]
      },
      color: "purple lighten-5",
      flat: false,
      media: false,
      loading: true,
      actions: true,
      outlined: false,
      elevation: undefined,
      raised: false,
      width: 344,
      height: undefined
    }
  },

  computed: {
    ...mapGetters(["staticsFormsDetails", "staticsFormsResume"]),
    /* statusFormComputed_old() {
      let color = 'white'
      if (this.inmueble.inmueble.enviadoLink) {
        color = 'amber lighten-1'
      }
      const key = parseInt(this.inmueble.key)
      if (!this.staticsFormsDetails || !this.staticsFormsDetails[`${this.catastroSelect}`] || !this.staticsFormsDetails[`${this.catastroSelect}`][`${key}`]) {
        return color;
      } 
      color = 'blue lighten-1';
      const datos = this.staticsFormsDetails[`${this.catastroSelect}`][`${key}`]
      const propietarios = datos.propietarios.length;
      const consolidados = datos.consolidados.length;
      const diferencia = propietarios - consolidados;
      console.log(`${this.catastroSelect} - ${key} => propietarios: ${propietarios} - consolidados: ${consolidados} = ${diferencia}`)
      if (diferencia < 1) {
        color = 'green lighten-1';
      }
      return color;
    }, */

    statusFormComputed() {
      let color = 'white'
      if (this.inmueble.inmueble.enviadoLink) {
        color = 'amber lighten-1'
      }

      if (this.propietariosForm && this.propietariosForm.length > 0) {
        color = 'blue lighten-1';
        if (this.propietariosFormNoMostrar >= this.propietariosForm.length ) {
          color = 'green lighten-1';
        }
      }

      return color;
    },

    propietariosForm() {
      let result = [];
      if (this.inmueble && this.inmueble.dataBurbuja && this.inmueble.dataBurbuja.propietarios) {
        result = this.inmueble.dataBurbuja.propietarios;
      }
      return result;
    },

    propietariosFormNoMostrar() {
      let result = 0;
      if (this.propietariosForm && this.propietariosForm.length > 0) {
        result = this.propietariosForm.filter(i => i.noMostrar).length;
      }
      return result;
    }
  },

  methods: {
    /* statusForm() {
      let color = 'white'
      if (this.inmueble.inmueble.enviadoLink) {
        color = 'amber lighten-1'
      }
      const key = parseInt(this.inmueble.key)
      if (!this.staticsFormsDetails || !this.staticsFormsDetails[`${this.catastroSelect}`] || !this.staticsFormsDetails[`${this.catastroSelect}`][`${key}`]) {
        return color;
      }
      color = 'blue lighten-1';
      const datos = this.staticsFormsDetails[`${this.catastroSelect}`][`${key}`]
      const propietarios = datos.propietarios.length;
      const consolidados = datos.consolidados.length;
      const diferencia = propietarios - consolidados;
      if (diferencia < 1) {
        color = 'green lighten-1'
      }
      return color;
    }, */
    // inmueble.isDataBurbuja === 'yes' ? 'green lighten-1' : 'amber lighten-1'
    addUser(inmueblekey) {
      this.$emit("addNewUser", inmueblekey)
    },

    editaData(inmueble) {
      this.$emit("editaDataInmueble", inmueble)
    }
  }
}
</script>
